'use client';

import { useSelector } from '@legendapp/state/react';
import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { useCarouselStateState } from './Carousel';
import { CarouselNavigationButton } from './CarouselNavigationButtons';
import { CarouselPagination } from './CarouselPagination';

export interface CarouselNavPagerPillProps extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'children'> {
    navClassName?: string;
}

export function CarouselNavPagerPill({ className, navClassName, ...props }: CarouselNavPagerPillProps) {
    const carouselState$ = useCarouselStateState();
    const scrollSnaps = useSelector(() => carouselState$.scrollSnaps.get());
    if (!scrollSnaps?.length) {
        return null;
    }

    return (
        <div className={cn('flex gap-4 items-center justify-center h-12.5 animate-in fade-in', className)} {...props}>
            <CarouselNavigationButton className={cn('relative h-12.5 w-12.5', navClassName)} center={false} variant="prev" aria-label="Previous slide" />
            <CarouselPagination className="mx-0" />
            <CarouselNavigationButton className={cn('relative h-12.5 w-12.5', navClassName)} center={false} variant="next" aria-label="Next slide" />
        </div>
    );
}
